import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_arrow_down",
  "use": "icon-icon_arrow_down-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-icon_arrow_down\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h16v16H0z\" /><path fill=\"#BEBFCA\" fill-rule=\"nonzero\" d=\"m8 8.781 3.3-3.3.943.943L8 10.667 3.757 6.424l.943-.943z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol